/**
 * https://docs.openstack.org/api-ref/compute/#list-keypairs
 */

import { OpenStackApiHelper } from 'utils/OpenStackApiHelper/OpenStackApiHelper';

import {
    CreateKeyPairRequest,
    CreateKeyPairResponse,
    DeleteKeyPairRequest,
    LoadKeyPairRequest,
    LoadKeyPairResponse,
    LoadKeyPairsListResponse,
} from './KeyPairsModule.types';
import {
    camelCaseApiItemData,
    snakeKeysItemData,
} from './KeyPairsModule.utils';

const BASE_URL = '/infra/compute/v2.1/os-keypairs';

export const KeyPairApi = {
    async loadList() {
        const { keypairs } = await OpenStackApiHelper.openstackRpcCall<
            LoadKeyPairsListResponse
        >({
            url: BASE_URL,
        });

        return keypairs.map(({ keypair }) => camelCaseApiItemData(keypair));
    },

    async loadKeyPair(name: LoadKeyPairRequest['name']) {
        const { keypair } = await OpenStackApiHelper.openstackRpcCall<
            LoadKeyPairResponse
        >({
            url: `${BASE_URL}/${name}`,
        });

        return camelCaseApiItemData(keypair);
    },

    removeKeyPair(name: DeleteKeyPairRequest['name']) {
        return OpenStackApiHelper.openstackRpcCall({
            url: `${BASE_URL}/${name}`,
            method: 'DELETE',
        });
    },

    async createKeyPair(newKeyPairData: CreateKeyPairRequest) {
        const { keypair } = await OpenStackApiHelper.openstackRpcCall<
            CreateKeyPairResponse
        >({
            url: BASE_URL,
            method: 'POST',
            data: {
                keypair: snakeKeysItemData(newKeyPairData),
            },
        });

        return camelCaseApiItemData(keypair);
    },
};
